// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .notifications {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #f6f3f3;
  color: #000;
  align-items: flex-end;
  z-index: 1000;
}
.theme-dark .notifications {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #333;
  color: #fffef9;
  align-items: flex-end;
  z-index: 1000;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/notifications/notifications.scss"],"names":[],"mappings":"AAqBI;ECjBA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EAEA,aAAA;AAHJ;ADaI;ECjBA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EAEA,aAAA;AAMJ;;AADA;EACI;IACE,UAAA;EAIJ;EAFE;IACE,UAAA;EAIJ;AACF;AADE;EACE;IACE,UAAA;IACA,wBAAA;EAGJ;EADE;IACE,UAAA;IACA,4BAAA;EAGJ;AACF","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.notifications {\n  @include themify($themes) {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    background-color: themed(\"bgSoft\");\n    color: themed(\"textColor\");\n    align-items: flex-end; // Align notifications to the right\n    // gap: 10px; // Space between notifications\n    z-index: 1000; // Ensure notifications appear above other elements\n\n  }\n}\n\n@keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n  \n  @keyframes fadeOut {\n    from {\n      opacity: 1;\n      transform: translateY(0);\n    }\n    to {\n      opacity: 0;\n      transform: translateY(-20px);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
